export class AuthSelectors {
  static getAuth = (state) => state.auth || {}
  static getToken = (state) => AuthSelectors.getAuth(state).token
  static getRefreshToken = (state) => AuthSelectors.getAuth(state).refreshToken
  static getUserId = (state) => AuthSelectors.getAuth(state).id
  static isAuthorized = (state) => !!AuthSelectors.getAuth(state).token
}
